import React from "react";

import SongList from "./SongList";
// import SongDetail from "./SongDetail";

import './App.css';



const App = () => {
  return (
    <div className="ui container grid">
      <div className="ui row">
      <div className="column sixteen wide">
        <SongList />
      </div>
      {/* <div className="column three wide">
        <SongDetail />
      </div> */}
      </div>
    </div>
  );
}

export default App;
